/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';
import * as _ from 'underscore';

export const curation = (state = defaultState.curation, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        inputs = [];

    if (action.status === constants.STATE_SUCCESS) {

        switch (action.type) {
            case constants.CURATION_ID:
                if (action.payload.length !== undefined && action.payload[0] !== undefined) {
                    nextState.route = action.payload[0];
                }
                break;

            case constants.CURATION_LIST:
                nextState.items = action.payload;
                break;

            case constants.CURATION_SHOW:
                for (i = 0; i < nextState.items.length; ++i) {
                    if (nextState.items[i].id == action.payload.id) {
                        nextState.items[i] = action.payload;
                        break;
                    }
                }
                break;

            case constants.CURATION_DELETE:
                for (i = 0; i < action.payload.length; ++i) {
                    nextState.items = _.reject(nextState.items, (item) => {
                        return item.id == action.payload[i];
                    });
                }
                // the count is of the same fresh items the list holds
                nextState.count = Math.max(0, Number(state.count) - (state.items.length - nextState.items.length));
                break;

            case constants.CURATION_COUNT:
                nextState.count = action.payload.count;
                break;

            case constants.CURATION_INPUT_SHOW:
            case constants.CURATION_INPUT_UPDATE:
                if (nextState.route.inputs) {
                    for (i = 0; i < nextState.route.inputs.length; ++i) {
                        if (nextState.route.inputs[i].id == action.payload.id) {
                            nextState.route.inputs[i] = action.payload;
                            break;
                        }
                    }
                }
                break;

            case constants.CURATION_INPUT_LOG:
                if (nextState.route.inputs) {
                    for (i = 0; i < nextState.route.inputs.length; ++i) {
                        if (nextState.route.inputs[i].id == action.payload.id) {
                            nextState.route.inputs[i].log = action.payload.log;
                            break;
                        }
                    }
                }
                break;

            case constants.CURATION_INPUT_CREATE:
                nextState.route.inputs.push(action.payload);
                break;

            case constants.CURATION_INPUT_DELETE:
                if (nextState.route.inputs) {
                    for (i = 0; i < nextState.route.inputs.length; ++i) {
                        if (nextState.route.inputs[i].id != action.payload.id) {
                            inputs.push(nextState.route.inputs[i]);
                        }
                    }
                    nextState.route.inputs = inputs;
                }
                break;

            case constants.CURATION_ROUTE_CREATE:
                nextState.route = action.payload;
                break;

            default:
                break;
        }
    }
    return nextState;
};
